import * as React from 'react';
import Breadcrumb from 'antd/es/breadcrumb';
import Icon from 'antd/es/icon';

interface IComponentProps {
  previous: string;
  previousHref: string;
  current?: string | null;
  currentAffix?: JSX.Element;
}

export const BackOfficeBreadcrumb = ({ current = '', previous, previousHref, currentAffix }: IComponentProps) => {
  return (
    <Breadcrumb separator={<Icon type="right" className="breadcrumb__label_inactive" />} className="breadcrumb mb-20">
      <Breadcrumb.Item href={previousHref}>
        <span className="breadcrumb__label_inactive">{previous}</span>
      </Breadcrumb.Item>

      <Breadcrumb.Item>
        <b>{current}</b>
        {currentAffix}
      </Breadcrumb.Item>
    </Breadcrumb>
  );
};
